import {
  deletePermission,
  getAllPermissions,
  newPermission,
  updatePermission,
} from '../../services/permissions';

export default {
  /**
   * Get all the permissions
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllPermissions({ commit }) {
    const response = await getAllPermissions();
    commit('setProperty', { property: 'permissions', payload: response });
  },

  /**
   *
   * @param commit
   * @param permissionId
   * @returns {Promise<void>}
   */
  async deletePermission({ commit }, { permissionId }) {
    await deletePermission(permissionId);
    commit('delProperty', { property: permissionId });
  },

  /**
   *
   * @param context
   * @param permissionId
   * @param permission
   * @returns {Promise<void>}
   */
  async updatePermission(context, { permissionId, permission }) {
    await updatePermission(permissionId, permission);
  },

  /**
   *
   * @param context
   * @param permission
   * @returns {Promise<void>}
   */
  async newPermission({ commit }, { permission }) {
    const response = await newPermission(permission);
    commit('setNewPermission', { payload: response });
  },
};
